<template>
    <div class="main-bg">
        <!-- <div class="rhead-login">
            <div class="rhead-login-main">
                <div class="rhead-login-l"><img src="../../assets/images/ztx_login.png"></div>
                <div class="rhead-login-r">
                    <router-link :to="{ path: '/login' }" class="rl-index">首页</router-link>
                    <div class="rl-compy">企业端</div>
                </div>
            </div>
        </div> -->
        <!-- <div class="loginbox">
            <div class="loginbox-main">
                <router-view></router-view>
            </div>
        </div> -->
        <div class="login-box">
            <router-view></router-view>
        </div>

        <div class="code" @click="openBeian">浙ICP备17049714号-2</div>
    </div>
</template>
<script>
export default {
    methods: {
        openBeian() {
            window.open('https://beian.miit.gov.cn/')
        }
    }
}
</script>
<style lang="less" scoped>
@import "../../assets/css/reglogin.less";
.main-bg{
    background-image: url(../../assets/images/login_bg.png) ;
    background-repeat: no-repeat;
    background-size: contain;
    background-color: #268CF7;
    height: 100%;
}
.login-box{
    width: 41rem;
    height: 44.8rem;
    background: #FFFFFF;
    box-shadow: 0px 0.5rem 1.2rem 0.5rem rgba(27,113,204,0.64);
    border-radius: 1rem;
    position: fixed;
    left: 50%;
    top: 16.5rem;
    margin-left: 20rem;
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 500px;
    min-width: 400px;
}
.code {
    position: fixed;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
    font-size: 16px;
    color: #333333;
}
</style>



// WEBPACK FOOTER //
// layout.vue?0ff65b18